/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import { IReducerAction, CrosstabVisualizationReducerActionData } from 'src/adhoc/store/types/ReducerTypes';
import { IState } from 'src/adhoc/store/types/StateTypes';
import multiAxisLevelLayoutAccessor from '../../../../store/accessors/multiAxisLevelLayout';

const shouldMergeCrosstabCells = (state: IState): boolean => {
    let needMergeCrosstabCells = true;
    const crosstabComponent = state.metadata.uiComponents.find((component) => (component.componentType === 'crosstab'));

    if (crosstabComponent && crosstabComponent.properties) {
        needMergeCrosstabCells = crosstabComponent.properties.mergeCrosstabCells
    }
    return needMergeCrosstabCells;
};

const shouldTakeAllAvailableWidth = (state: IState): boolean => {
    let takeAllAvailableWidth = false;
    const crosstabComponent = state.metadata.uiComponents.find((component) => (component.componentType === 'crosstab'));

    if (crosstabComponent && crosstabComponent.properties) {
        takeAllAvailableWidth = crosstabComponent.properties.useAllAvailableWidth
    }

    return takeAllAvailableWidth;
};

export default function crosstabVisualizationStaticPropertiesReducer(staticProperties: any, state: IState, action: IReducerAction<CrosstabVisualizationReducerActionData>) {
    return {
        levelsStructure: multiAxisLevelLayoutAccessor(state),
        properties: {
            mergeCrosstabCells: shouldMergeCrosstabCells(state),
            takeAllAvailableWidth: shouldTakeAllAvailableWidth(state)
        }
    };
}
